export default {
  "auth.login.title": "Log in",
  "auth.login.subtitle": "Enter your laundry account details to access the dashboard.",
  "auth.login.email": "Email",
  "auth.login.password": "Password",
  "auth.login.emailPlaceholder": "name@laundry.com",
  "auth.login.passwordPlaceholder": "••••••••",
  "auth.login.showPassword": "Show password",
  "auth.login.hidePassword": "Hide password",
  "auth.login.submit": "Log in",
  "auth.login.quickDemo": "Quick demo login",
  "auth.login.quickDemoHint": "Signs you in directly with the approved account, without typing any details.",
  "auth.login.forgot": "Forgot your password?",
  "auth.login.registerLink": "Register a new laundry",
  "auth.login.errorRequired": "Please enter your email and password.",
  "auth.login.errorInvalid": "Incorrect login details. Check your email and password.",
  "auth.login.errorPending": "Your account is still under admin review. You will be notified by email once approved.",
  "auth.login.errorRejected": "Your laundry registration was rejected.",
  "auth.login.reasonLabel": "Rejection reason:",
  "auth.login.demoHint": "Demo credentials: laundry@laundrybox.sa / 12345678 (approved account)",
  "auth.login.demoPendingHint": "Under-review account: pending@laundrybox.sa / 12345678",
  "auth.login.demoRejectedHint": "Rejected account: rejected@laundrybox.sa / 12345678",
  "auth.login.brandTitle": "Run your whole laundry",
  "auth.login.brandText": "Orders, drivers, items & services, and finance in one place.",
  "auth.brand.feature.orders": "Manage orders and their statuses from one screen",
  "auth.brand.feature.drivers": "Track sub-drivers and manual assignment",
  "auth.brand.feature.finance": "Follow finance and settlements with clarity",

  "auth.register.title": "Register a new laundry",
  "auth.register.subtitle": "Complete the details below; the request will be sent to admin for review.",
  "auth.register.section.laundry": "Laundry details",
  "auth.register.section.address": "Address & coverage",
  "auth.register.section.hours": "Working hours",
  "auth.register.section.docs": "Documents",
  "auth.register.name": "Laundry name",
  "auth.register.description": "Short description",
  "auth.register.logo": "Laundry image or logo",
  "auth.register.phone": "Contact phone number",
  "auth.register.email": "Email",
  "auth.register.password": "Password",
  "auth.register.passwordHint": "At least 8 characters.",
  "auth.register.city": "City",
  "auth.register.cityPlaceholder": "Select a city",
  "auth.register.mapLabel": "Set the laundry address on the map",
  "auth.register.mapHint": "The map reflects the city, district and address you enter.",
  "auth.register.mapSelectCityHint": "Select a city first to show your location on the map.",
  "auth.register.district": "District",
  "auth.register.street": "Street",
  "auth.register.building": "Building number",
  "auth.register.coverage": "Districts covered by the laundry",
  "auth.register.coverageHint": "Select the available districts in the chosen city.",
  "auth.register.coverageEmpty": "Select a city first to see available districts.",
  "auth.register.fromTime": "From",
  "auth.register.toTime": "To",
  "auth.register.docsHint": "Required documents are defined by admin.",
  "auth.register.doc.commercial": "Commercial registration",
  "auth.register.doc.id": "National ID",
  "auth.register.uploadFile": "Upload file",
  "auth.register.replaceFile": "Replace",
  "auth.register.removeFile": "Remove",
  "auth.register.noFile": "No file selected",
  "auth.register.uploadRule": "Allowed formats and sizes are configurable per the admin upload service.",
  "auth.register.submit": "Submit registration request",
  "auth.register.errorFix": "Please fix the required fields before submitting.",
  "auth.register.passwordMismatch": "Passwords do not match.",
  "auth.register.confirmPassword": "Confirm password",
  "auth.register.reviewTitle": "Your request is under review",
  "auth.register.reviewText": "Your laundry registration request has been received. Admin will review the data and documents, and the review result will be sent to your email.",
  "auth.register.reviewAccepted": "Once approved, login and service setup become available.",
  "auth.register.reviewToLogin": "Back to login",
  "auth.register.demoNotice": "This is a preview with demo data.",

  "auth.reset.title": "Reset password",
  "auth.reset.stepEmail": "Email",
  "auth.reset.stepCode": "Verification code",
  "auth.reset.stepPassword": "New password",
  "auth.reset.emailIntro": "Enter the registered email to receive a verification code.",
  "auth.reset.sendCode": "Send verification code",
  "auth.reset.codeIntro": "Enter the verification code sent to your email.",
  "auth.reset.codeSentTo": "Verification code sent to:",
  "auth.reset.code": "Verification code",
  "auth.reset.codePlaceholder": "Enter the code",
  "auth.reset.verify": "Verify",
  "auth.reset.resend": "Resend code",
  "auth.reset.validity": "The code is valid for {{minutes}} minutes per admin settings.",
  "auth.reset.errorInvalidCode": "Incorrect verification code.",
  "auth.reset.errorExpiredCode": "The verification code has expired. Request a new one.",
  "auth.reset.newPassword": "New password",
  "auth.reset.confirmPassword": "Confirm new password",
  "auth.reset.submit": "Set password",
  "auth.reset.mismatch": "Passwords do not match.",
  "auth.reset.successTitle": "Password updated",
  "auth.reset.successText": "You can now log in with your new password.",
  "auth.reset.toLogin": "Go to login",
  "auth.reset.backToLogin": "Back to login",
  "auth.reset.demoNotice": "This is a preview with demo data."
};